import React, { useEffect } from "react";
import Container from "react-bootstrap/Container";
import LoginWrap from "./style";
import LoginForm from "../../Reuseable/Forms/LoginForm";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Login = ({ props }) => {
  const isLoggedIn = useSelector(state => state.Auth.isLoggedIn);
  const user = useSelector(state => state.Auth.user);
  const navigate = useNavigate()

  useEffect(() => {
    isLoggedIn ? user === "Admin" ? navigate('/home/pre-bidding') : navigate("home/auction") : navigate('/admin')
  }, [isLoggedIn, navigate, user])

  return (
    <LoginWrap>
      <section className="loginPageContent" >
        <Container className="container-width bg-white">
          <LoginForm props={props} />
        </Container>
      </section>
    </LoginWrap>
  );
};

export default Login;
